"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateFromTimestamp = exports.timestamp = exports.convertYear = exports.getName = exports.getIndex = exports.convertMonthName = exports.convertDayName = exports.newDate = void 0;
var __1 = require("..");
var enDayShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var enDayLong = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
var thDayShort = ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัส", "ศุกร์", "เสาร์"];
var thDayLong = ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"];
var day = {
    en: {
        short: enDayShort,
        long: enDayLong,
    },
    th: {
        short: thDayShort,
        long: thDayLong,
    },
};
var enMonthShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var enMonthLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
var thMonthShort = [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค.",
];
var thMonthLong = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
];
var month = {
    en: {
        short: enMonthShort,
        long: enMonthLong,
    },
    th: {
        short: thMonthShort,
        long: thMonthLong,
    },
};
/**
 * create new Date object by input object
 *
 * @param opt datetime object (each key start point is 0)
 * @param type datetime timezone
 */
var newDate = function (opt, type) {
    if (type === void 0) { type = "UTC"; }
    var option = __1.json.forceObject(__1.json.merge({ year: 0, month: 0, date: 0, hour: 0, minute: 0, second: 0, millisecond: 0 }, opt));
    if (option.year === 0 &&
        option.month === 0 &&
        option.date === 0 &&
        option.hour === 0 &&
        option.minute === 0 &&
        option.second === 0 &&
        option.millisecond === 0)
        return new Date();
    else {
        if (type === "UTC")
            return new Date(Date.UTC(option.year, option.month, option.date, option.hour, option.minute, option.second, option.millisecond));
        else
            return new Date(option.year, option.month, option.date, option.hour, option.minute, option.second, option.millisecond);
    }
};
exports.newDate = newDate;
/**
 * convert day name to day index start with 0, returns -1 if not found
 *
 * @param dayName day name in string
 * @param opt specify the name type, passes undefined will search all day name in database
 */
var convertDayName = function (dayName, opt) {
    if (__1.generic.noExist(opt)) {
        for (var _i = 0, _a = ["short", "long"]; _i < _a.length; _i++) {
            var t = _a[_i];
            for (var _b = 0, _c = ["en", "th"]; _b < _c.length; _b++) {
                var l = _c[_b];
                var i = exports.convertDayName(dayName, { lang: l, type: t });
                if (i >= 0)
                    return i;
            }
        }
        return -1;
    }
    else {
        var arr = day[opt.lang][opt.type];
        return arr.findIndex(function (m) { return m.toLowerCase() === dayName.toLowerCase(); });
    }
};
exports.convertDayName = convertDayName;
/**
 * convert month name to month index start with 0, returns -1 if not found
 *
 * @param monthName month name in string
 * @param opt specify the name type, passes undefined will search all month name in database
 */
var convertMonthName = function (monthName, opt) {
    if (__1.generic.noExist(opt)) {
        for (var _i = 0, _a = ["short", "long"]; _i < _a.length; _i++) {
            var t = _a[_i];
            for (var _b = 0, _c = ["en", "th"]; _b < _c.length; _b++) {
                var l = _c[_b];
                var i = exports.convertMonthName(monthName, { lang: l, type: t });
                if (i >= 0)
                    return i;
            }
        }
        return -1;
    }
    else {
        var arr = month[opt.lang][opt.type];
        return arr.findIndex(function (m) { return m.toLowerCase() === monthName.toLowerCase(); });
    }
};
exports.convertMonthName = convertMonthName;
var getIndex = function (name, key, opt) {
    if (key === "day")
        return exports.convertDayName(name, opt);
    else if (key === "month")
        return exports.convertMonthName(name, opt);
    else
        return -1;
};
exports.getIndex = getIndex;
var getName = function (index, opt) {
    if (__1.generic.noExist(opt.key) || __1.generic.noExist(opt.type) || __1.generic.noExist(opt.lang))
        return undefined;
    var base = opt.key === "day" ? day : month;
    var arr = base[opt.lang][opt.type];
    if (index >= arr.length)
        return undefined;
    else
        return arr[index];
};
exports.getName = getName;
/**
 * convert year from type to global year number
 *
 * Thai year example:
 *   - 54    => 2011
 *   - 61    => 2018
 *   - 2544  => 2001
 *   - 2565  => 2022
 *   - 5     => 1962
 *   - 612   => 2037
 *   - Y65   => 2022
 *
 * Global year example
 *   - 12    => 2012
 *   - 25    => 2525
 *   - 2044  => 2044
 *   - 2001  => 2001
 *   - 5     => 2005
 *   - 612   => 2612
 *   - Y18   => 2018
 *
 * @param year year string
 * @param type year type
 */
var convertYear = function (year, type) {
    if (type === void 0) { type = "thai"; }
    var prefix = type === "thai" ? "25" : "20";
    var converter = type === "thai" ? -543 : 0;
    var yearn = year.split("").reduce(function (p, c) { return (isNaN(parseInt(c)) ? p : p + c); }, ""); // remove all non-number string
    var year1 = yearn.padStart(2, "0"); // padding start with 0 if string length is 1
    var year2 = year1.length === 2 ? "" + prefix + year1 : year1; // add 25 if year length is 2
    var year3 = year2.length === 3 ? "" + prefix.charAt(0) + year2 : year2; // add 2 if year length is 3
    var year4 = year3.length > 4 ? year3.substr(year3.length - 4, 4) : year3; // trim all string more than 4
    var int = parseInt(year4);
    return int + converter;
};
exports.convertYear = convertYear;
var timestamp = function (input, type) {
    if (type === void 0) { type = "millisecond"; }
    var date = __1.generic.isString(input) || __1.generic.isNumber(input) ? new Date(input) : input;
    var ms = date.getTime();
    return type === "millisecond" ? ms : Math.round(ms / 1000);
};
exports.timestamp = timestamp;
var getDateFromTimestamp = function (timestamp) {
    if (__1.generic.isString(timestamp)) {
        if (/^(\d)+$/.test(timestamp)) {
            var number = parseInt(timestamp, 10);
            return new Date(number);
        }
        else
            return undefined;
    }
    return isNaN(timestamp) || !isFinite(timestamp) ? undefined : new Date(timestamp);
};
exports.getDateFromTimestamp = getDateFromTimestamp;
//# sourceMappingURL=datetime.js.map